// extracted by mini-css-extract-plugin
export default {"skeleton":"home_skeleton__evyVK","home":"home_home__qA4gR","article":"home_article__rkM1s"};